var exports = {
  "V": "compactIcon__oUiNeu",
  "a": "selectorButton___EY-DC",
};

module.exports = exports;
